import React, { useEffect, useState } from 'react';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import {
  ListGroup,
  ListGroupItem,
  Nav,
  Navbar,
  NavItem,
  NavLink,
  Popover,
  PopoverBody,
} from 'reactstrap';
import bn from 'utils/bemnames';
import './Header.css';
import Avatar from 'components/Avatar';

import { Button as Button2, Typography } from "@material-ui/core"
import {
  Button,
  Chip,
  Fade,
  IconButton,
  MenuItem,
  Paper,
  Popper,
  Stack,
} from '@mui/material';

import {
  MdClearAll,
  MdExitToApp,
  MdHelp,
  MdInsertChart,
  MdMessage,
  MdNotificationsActive,
  MdNotificationsNone,
  MdPersonPin,
  MdSettingsApplications,
} from 'react-icons/md';
import logoqa from '../../assets/img/users/setting.png';
import logoqa2 from '../../assets/img/sidebar/logo.jpg';
import { useHistory } from 'react-router-dom';

import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import UserCard from '../Card/UserCard';
import { FaBuilding } from "react-icons/fa";
import { CgCalendarDates } from "react-icons/cg";
const bem = bn.create('header');

const Header = () => {
  const history = useHistory();
  const theme = useTheme();
  const matchesmallscreen = useMediaQuery(theme.breakpoints.down('md'));
  const [isOpenUserCardPopover, setIsOpenUserCardPopover] = useState(false);
  const [isSidebarMinimized, setIsSidebarMinimized] = React.useState(false);

  const handleLogout = () => {
    localStorage.clear();
    history.push('/');
  };

  // const initialSidebarState = localStorage.getItem('isSidebarMinimized') === 'true' ? true : false;
  // const [isSidebarMinimized, setIsSidebarMinimized] = useState(initialSidebarState);

  const handleSidebarControlButton = event => {
    event.preventDefault();
    event.stopPropagation();
    const sidebar = document.querySelector('.cr-sidebar');
    sidebar.classList.toggle('cr-sidebar--open');
    setIsSidebarMinimized(!sidebar.classList.contains('cr-sidebar--open'));
    localStorage.setItem(
      'isSidebarMinimized',
      !sidebar.classList.contains('cr-sidebar--open'),
    );
   
  };

  // const handleSidebarControlButton = event => {
  //   event.preventDefault();
  //   event.stopPropagation();
  //   const sidebar = document.querySelector('.cr-sidebar');
  //   sidebar.classList.toggle('cr-sidebar--open');
  //   const sidebarOpen = !sidebar.classList.contains('cr-sidebar--open');
  //   setIsSidebarMinimized(sidebarOpen);
  // };

  const toggleUserCardPopover = () => {
    setIsOpenUserCardPopover(!isOpenUserCardPopover);
  };

  const initialSidebarState2 = localStorage.getItem('isSidebarMinimized');

  return (
    <header
      className={`sticky-topheader py-2 mb-3 bg-white bottoms-shadow ${
        isSidebarMinimized || matchesmallscreen ? 'w-100' : 'cr-header2'
      }`}
    >
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        spacing={1}
        px={0}
      >
        {/* <IconButton
          aria-label=""
          onClick={handleSidebarControlButton}
          color="success"
        > */}
    {localStorage.getItem('Qauser') == 'N'?  (
      <div style={{display:'flex',}}>
         <MenuOpenIcon   onClick={handleSidebarControlButton} />
         <p style={{fontSize:15,marginLeft:20,}}>    COMPANY : {localStorage.getItem("CompanyName")}</p><br/>

         <p style={{fontSize:15,marginLeft:20,}}>    FINANCIAL YEAR : {localStorage.getItem("FInalyear")}</p>
         </div>
    ) : <></>}
         

      
          {/* <div >

          </div> */}
        
        {/* </IconButton> */}
    
        {/* <Stack
                direction={"column"}
                justifyContent={"flex-start"}
                alignItems={"flex-start"}
                ml={1}
              
              >
                <Button2
                  variant="text"
                
                  startIcon={

                    <FaBuilding />
                    // <i className="fas fa-building" color="#213555"></i>
                  }
                  style={{
                    color: "#213555",
                  }}
                >
                  <Typography variant="subtitle2" color="inherit">
                    COMPANY : {localStorage.getItem("CompanyName")}
                  </Typography>
                </Button2>
                <Button2
                  variant="text"
             
                  startIcon={
                    <CgCalendarDates />
                  }
                  style={{
                  color: "#213555",
                  }}
                >
                  <Typography variant="subtitle2" color="inherit">
                    {" "}
                    FINANCIAL YEAR : {localStorage.getItem("FInalyear")}
                  </Typography>
                </Button2>

            
              </Stack> */}
        <div>
        <div>

</div>
</div>

        {(isSidebarMinimized || matchesmallscreen) && (
          <div
            className="bg-white mx-2 p-0 card"
            style={{
              maxWidth: matchesmallscreen ? '30%' : '10%',
            }}
          >
            <img
              src={logoqa2}
              style={{ objectFit: 'contain', borderRadius: 20 }}
              alt="logoqa"
              className="px-2"
            />
          </div>
        )}
        <div id="Popover2">
          {matchesmallscreen ? (
            <Avatar onClick={toggleUserCardPopover} className="can-click" />
          ) : (
            <Button onClick={toggleUserCardPopover}>
              <Chip
                style={{ fontWeight: 'bolder' }}
                avatar={<Avatar alt="Admin" src={logoqa} />}
                label={localStorage.getItem('UserCode')}
                variant="outlined"
                size="medium"
                color="success"
                className={`${matchesmallscreen ? 'py-2' : 'py-4'} can-click`}
              />
            </Button>
          )}
        </div>
        <Popover
          placement="bottom-end"
          isOpen={isOpenUserCardPopover}
          toggle={toggleUserCardPopover}
          target="Popover2"
          className="p-0 border-0"
          style={{ minWidth: 250 }}
        >
          <PopoverBody className="p-0 border-light">
            <UserCard title={localStorage.getItem('username')}>
              <ListGroup flush>
                <ListGroupItem tag="button" action className="border-light">
                  <MenuItem onClick={handleLogout} sx={{ m: 1 }}>
                    <MdExitToApp /> <span className="ml-2">Logout</span>
                  </MenuItem>
                </ListGroupItem>
              </ListGroup>
            </UserCard>
          </PopoverBody>
        </Popover>

        {/* </NavItem> */}
      </Stack>
    </header>
  );
};

export default Header;
